import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getSketchNoteStyles = (theme: Theme) =>
  StyleSheet.create({
    row: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: 6,
      marginTop: 8,
      paddingHorizontal: 4,
    },
    rowCenter: {
      justifyContent: 'center',
    },
    rowRight: {
      justifyContent: 'flex-end',
    },
    arrow: {
      marginTop: 2,
      flexShrink: 0,
    },
    arrowMirrored: {
      transform: [{ scaleX: -1 }],
    },
    text: {
      maxWidth: 200,
      fontSize: 16,
      fontWeight: '700',
      fontStyle: 'italic',
      lineHeight: 19,
      transform: [{ rotate: '-2.5deg' }],
      color: theme.accentLight,
    },
  });
